'use client';

import Fade from 'embla-carousel-fade';
import useEmblaCarousel from 'embla-carousel-react';
import { FC } from 'react';
import EmblaSlider from '~/components/embla-slider';
import EmblaContainer from '~/components/embla-slider/container';
import SliderNavigation from '~/components/embla-slider/navigation';
import EmblaSlide from '~/components/embla-slider/slide';
import ClientItem from '~/data/strapi/types/shared-blocks/block-clients/client-item';
import alt from '~/utils/default-alt';
import getDataPath from '~/utils/get-data-path';

import styles from './styles.module.css';

interface Props {
  partners: ClientItem[];
}

const ClientsMobileSlider: FC<Props> = ({ partners }) => {
  const [ref, carousel] = useEmblaCarousel({ loop: true }, [Fade()]);

  const nextSlide = () => {
    carousel?.scrollNext();
  };

  const prevSlide = () => {
    carousel?.scrollPrev();
  };

  const groupPartners = (chunkSize: number) => {
    const originalArray = [...partners];
    const groupedArray = [];

    for (let i = 0; i < originalArray.length; i += chunkSize) {
      groupedArray.push(originalArray.slice(i, i + chunkSize));
    }

    return groupedArray;
  };

  const groupedPartners = groupPartners(2);

  return (
    <EmblaSlider ref={ref} className={styles.slider}>
      <EmblaContainer className={styles.sliderContainer}>
        {groupedPartners.map((partnerGroup, index) => (
          <EmblaSlide className={styles.slide} key={'group-' + index}>
            {partnerGroup.map((partner) => {
              const image = partner.image;
              const alternativeText = image?.alternativeText;

              if (!image) return null;

              return (
                <div className={styles.imgWrap} key={partner.id}>
                  <img src={getDataPath(image.url)} alt={alt(alternativeText)} className={styles.img} />
                </div>
              );
            })}
          </EmblaSlide>
        ))}
      </EmblaContainer>

      <SliderNavigation onNext={nextSlide} onPrev={prevSlide} containerClassName={styles.navigation} />
    </EmblaSlider>
  );
};

export default ClientsMobileSlider;
